<template>
  <div>
    <dialog-v2
      :show="dialog"
      :title="title"
      :disable-save-btn="disabledBtnSave"
      @close="$emit('close')"
      :max-width="maxWidth"
      @save="checkTemplate"
    >
      <template slot="content">
        <v-layout row wrap class="align-center">
          <template v-if="!isPaymentType && showUnusedFields">
            <v-flex xs4>
              <v-text-field
              :disabled="!isInRelease"
              class="px-2 w-100"
                v-model="filterClone[`attemps_${daysOffG[channel]}`]"
                label="Cant Intentos"
                v-validate="'required|integer'"
                data-vv-name="attemps"
                data-vv-scope="filter"
                data-vv-as="ventana de tiempo grupo bot/ivr"
                color="black"
                :error-messages="errors.collect('attemps')"/>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              :disabled="!isInRelease"
              class="px-2 w-100"
              label="V Intentos"
                v-model="filterClone[`days_off_attemps_${daysOffG[channel]}`]"
                v-validate="'required|integer'"
                data-vv-name="days_off_attemps"
                data-vv-scope="filter"
                data-vv-as="ventana de tiempo grupo bot/ivr"
                color="black"
                :error-messages="errors.collect('days_off_attemps')"/>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              class="px-2 w-100"
              label="V Contacto"
                v-model="filterClone[`days_off_${daysOffG[channel]}`]"
                v-validate="'required|integer'"
                data-vv-name="days_off"
                data-vv-scope="filter"
                data-vv-as="ventana de tiempo grupo bot/ivr"
                color="black"
                :error-messages="errors.collect('days_off')"/>
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-if="channel !== 'email' && isNewWorkflow" row wrap class="align-center">
          <v-flex
            :xs4="channel === 'sms'"
            :xs12="channel !== 'sms'"
          >
            <v-select
              v-model="filterClone[`${channel}_owner_id`]"
              :items="phoneOwners"
              class="px-2 w-100"
              item-value="id"
              item-text="name"
              label="Tipo de teléfono"
              color="black"
            />
          </v-flex>
          <template v-if="channel === 'sms'">
            <v-flex xs4>
              <v-select
                v-model="filterClone.sms_cs_journey"
                :items="csJourneys"
                class="px-2 w-100"
                item-value="id"
                item-text="name"
                label="Etapa"
                color="black"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model.number="filterClone.sms_check_days"
                class="px-2 w-100"
                label="Cantidad de días en consideración"
                type="number"
                color="black"
                min="1"
                :rules="[greaterThanZeroInputRule]"
                @keypress.45.prevent
              />
            </v-flex>
            <v-flex xs12>
              <v-checkbox
                v-model="filterClone.only_contacted_sms"
                :hide-details="true"
                class="pr-2 sms-config-checkbox w-100"
                label="Sólo números dentro de la configuración"
              />
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-if="usesCollyTemplates" row wrap class="align-center">
          <v-flex xs12>
            <v-select
              v-model="form.colly_sender_id"
              :items="[{ id: null, display_name: 'Por defecto' }].concat(collySenders)"
              :loading="collySendersLoading"
              :disabled="collySendersLoading"
              class="px-2 w-100"
              item-value="id"
              item-text="display_name"
              :label="channel === 'email' ? 'Remitente' : 'Número'"
              color="black"
              @input="loadCollyTemplates"
            />
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="form.colly_template_id"
              :items="collyTemplates"
              :loading="collyTemplatesLoading"
              :disabled="collyTemplatesLoading"
              class="px-2 w-100"
              item-value="id"
              item-text="display_name"
              label="Plantilla"
              color="black"
              no-data-text="Sin plantillas compatibles con el remitente"
            />
            <small v-if="senderLookupError" class="red--text px-2">{{ senderLookupError }}</small>
            <small v-if="collyRequestError" class="red--text px-2">{{ collyRequestError }}</small>
          </v-flex>
        </v-layout>
        <template v-else-if="channel === 'email'">
          <v-layout row wrap justify-space-between align-center>
            <v-flex md10>
              <v-select
                v-model="form.company_email_id"
                v-validate="'required'"
                data-vv-name="company_email_id"
                :data-vv-scope="validationScope"
                data-vv-as="email"
                :error-messages="errors.collect(`${validationScope}.company_email_id`)"
                :items="emailList"
                item-value="id"
                label="Email"
                color="black"
              >
                <template slot="item" slot-scope="item">
                  {{ item.item.from_name }}
                  <small class="ml-2">{{ item.item.email }}</small>
                </template>
                <template slot="selection" slot-scope="selection">
                  {{ selection.item.from_name }}
                  <small class="ml-2">{{ selection.item.email }}</small>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs1>
              <v-btn icon @click="editEmail" :disabled="!form.company_email_id">
                <v-icon small>fas fa-pencil-alt</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs1>
              <v-btn icon @click="emailDialog = true">
                <v-icon small>fas fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form.subject"
                v-validate="'required|max:100'"
                data-vv-name="subject"
                :data-vv-scope="validationScope"
                data-vv-as="asunto"
                :error-messages="errors.collect(`${validationScope}.subject`)"
                label="Asunto"
                color="black"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="isNewWorkflow" row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form.email_name"
                v-validate="'min:3|max:100'"
                maxlength="100"
                data-vv-name="email_name"
                :data-vv-scope="validationScope"
                data-vv-as="nombre"
                :error-messages="errors.collect(`${validationScope}.email_name`)"
                label="Nombre (opcional)"
                color="black"
              />
            </v-flex>
          </v-layout>
        </template>
        <v-layout v-if="!usesCollyTemplates" row wrap mt-3>
          <v-flex xs12>
            <div class="editor">
              <editor-menu-bar v-if="channel === 'email'" :editor="editor">
                <div class="menubar" slot-scope="{ commands, isActive }">
                  <v-btn
                    v-for="(item, i) in menuBar"
                    :key="`menubar-item-${i}`"
                    :class="{ 'v-btn--active': item.checkActive && (item.active || isActive[item.name](item.props || {})) }"
                    @click="(item.callback || commands[item.name])(item.props || {})"
                    small
                    icon
                    :disabled="editingHtml && item.name !== 'code'"
                  >
                    <v-icon small>{{ item.icon }}</v-icon>
                  </v-btn>
                </div>
              </editor-menu-bar>
              <editor-menu-bubble class="menububble" :editor="editor" @hide="hideLinkMenu">
                <div
                  slot-scope="{ commands, menu, getMarkAttrs }"
                  :class="{ 'menububble': true, 'is-active': linkMenuIsActive }"
                  :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
                >
                  <form
                    class="menububble__form"
                    @submit.prevent="setLinkUrl(commands.link, linkUrl)"
                  >
                    <v-text-field
                      :value="getMarkAttrs('link').href"
                      color="black"
                      placeholder="https://"
                      :hide-details="true"
                      @input="linkUrl = $event"
                      @keydown.esc="hideLinkMenu"
                      solo
                    />
                    <v-btn icon class="menububble__button" @click="setLinkUrl(commands.link, null)">
                      <v-icon small color="white">fas fa-times-circle</v-icon>
                    </v-btn>
                  </form>
                </div>
              </editor-menu-bubble>
              <editor-content v-show="!editingHtml" :editor="editor" class="template-editor" />
              <textarea v-if="editingHtml" v-model="htmlCode" id="html-text" class="material" />
            </div>
            <small class="red--text" v-if="textError">Debe ingresar un texto</small>
            <span
              v-if="!textError && !editingHtml && channel === 'sms'"
              v-bind:class="{ activeClass: totalCharacter > maxChars }">
              Limite de Caracteres {{ totalCharacter }} / {{ maxChars }}<br>
              <span v-if="form.sms_enable_short_url">
                Cada link cuenta como {{ shortlinkCharacterCount }} caracteres
              </span>
            </span><br>
              <span class="activeClass" v-if="!textError && !editingHtml && channel === 'sms' && hasSpecialChar">
                No se admiten caracteres especiales en las plantillas SMS
              </span><br>
              <span class="activeClass" v-if="totalCharacter > maxChars && channel === 'sms'">
                No se permiten mas de {{ maxChars }} caracteres para sms
              </span>
          </v-flex>
          <v-layout row wrap>
          <v-flex xs12 v-if="channel === 'sms' || channel === 'whatsapp'">
            <v-checkbox
              v-model="form.sms_enable_short_url"
              class="pr-2 w-100"
              label="Acortar links"
              :persistent-hint="true"
              hint="Cualquier link dentro del mensaje se reemplazara automaticamente por un link acortado al ser enviado"
            />
          </v-flex>
        </v-layout>
          <div v-if="hasStaging" class="mt-3">
            <p class="mb-0 text-xs">{{ getText }}</p>
            <div class="template-staging-div" @click="changeTemplate">
              {{ !stagingMode ? 'Ver' : 'Volver atrás' }}
            </div>
          </div>
        </v-layout>
      </template>
    </dialog-v2>
    <div class="suggestion-list" v-show="showSuggestions" ref="suggestions">
      <template v-if="hasResults">
        <div
          v-for="(variable, i) in filteredVars"
          :key="`var-${i}`"
          class="suggestion-list__item"
          :class="{ 'is-selected': selectedVarIndex === i }"
          @click="selectVar(variable)"
        >{{ variable }}</div>
      </template>
      <div v-else>No hay variables</div>
    </div>
    <email-dialog
      :show="emailDialog"
      :email="selectedEmail"
      :validation-scope="validationEmailScope"
      @created="emailList.push($event)"
      @updated="updateEmail"
      @close="emailDialog = false"
    />
    <double-check
      :show="showChecker"
      @accept="doubleCheckPassed"
      @close="showChecker = false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap';
import * as Extensions from 'tiptap-extensions';
import tippy from 'tippy.js';
import DialogV2 from '@/components/global/DialogV2';
import EmailDialog from '@/components/Emails/Index';
import DoubleCheck from '@/components/templateV2/modal/DoubleCheck';
import workflowFiltersMixin from '@/mixins/workflowFilters';
import { setTimeout } from 'timers';

/** `templates/staging` rows are per channel_id; align with channelsV2 / workflow APIs */
const WORKFLOW_TEMPLATE_STAGING_CHANNEL_IDS = {
  email: 1,
  sms: 2,
  whatsapp: 7,
  human: 5,
};

export default {
  inject: {
    $validator: '$validator',
    // Lo provee la página del flujo de cobranza (carga el release una vez).
    collyRelease: { default: () => ({}) },
  },
  props: {
    showUnusedFields: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
    template: {
      type: Object,
      required: false,
    },
    validationScope: {
      type: String,
      default: 'template',
    },
    validationEmailScope: {
      type: String,
      default: 'companyEmail',
    },
    appendVars: {
      type: Array,
      default: () => [],
    },
    stagingStatus: {
      type: Boolean,
      default: false,
    },
    templateStaging: {
      type: Object,
      default: () => ({}),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    activateCheck: {
      type: Boolean,
      default: false,
    },
    // We should use Vuex Store for these flags
    isInRelease: {
      type: Boolean,
      default: false,
    },
    isNewWorkflow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Editar plantilla',
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
    EmailDialog,
    DoubleCheck,
    DialogV2,
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  data() {
    const varsList = _.uniq([
      '@nombre',
      '@apellido',
      '@nombre_completo',
      '@folio',
      '@fecha_envio',
      '@monto',
      '@cuenta',
      '@descripcion',
      '@mañana',
      ...this.appendVars.map(item => `@${item}`),
    ]);
    return {
      filterClone: {},
      daysOffG: {
        human: 'g1',
        bot: 'g2',
        ivr: 'g2',
        sms: 'g3',
        email: 'g4',
        whatsapp: 'g5',
      },
      stagingMode: false,
      showChecker: false,
      stagingMoment: '',
      stagingEmail: {},

      dialog: false,
      collyTemplates: [],
      collyTemplatesLoading: false,
      collySenders: [],
      collySendersLoading: false,
      collyRequestError: '',
      senderLookupError: '',
      emailList: [],
      emailDialog: false,
      editor: new Editor({
        onUpdate: ({ getHTML }) => {
          if (this.channel === 'email') {
            this.htmlCode = getHTML();
            this.form.text = this.htmlCode;
          } else {
            this.htmlCode = getHTML();
            // SMS: preservar Enter como salto real (LF). Otros canales: strip plano histórico.
            this.form.text = this.channel === 'sms'
              ? this.smsHtmlToPlainText(getHTML())
              : this.removeHtmlTagsHard(getHTML());
            if (this.channel === 'sms') {
              this.charLength = parseInt(this.form.text.length, 10) - this.charLength;
            }
          }
          if (!this.form.text && this.channel !== 'human') {
            this.textError = true;
          } else {
            this.textError = false;
          }
        },
        extensions: [
          new Extensions.Placeholder({
            emptyClass: 'is-empty',
            emptyNodeText: 'Escriba aqui un texto...',
            showOnlyWhenEditable: true,
          }),
          new Extensions.Blockquote(),
          new Extensions.Bold(),
          new Extensions.BulletList(),
          new Extensions.Code(),
          new Extensions.CodeBlock(),
          new Extensions.CodeBlockHighlight(),
          new Extensions.HardBreak(),
          new Extensions.Heading({
            levels: [1, 2, 3],
          }),
          new Extensions.Mention({
            // a list of all suggested items
            items: () => varsList,
            // is called when a suggestion starts
            onEnter: ({ items, query, range, command, virtualNode }) => {
              this.query = query;
              this.filteredVars = items;
              this.suggestionRange = range;
              this.renderPopup(virtualNode);
              // we save the command for inserting a selected mention
              // this allows us to call it inside of our custom popup
              // via keyboard navigation and on click
              this.insertMention = command;
            },
            // is called when a suggestion has changed
            onChange: ({ items, query, range, virtualNode }) => {
              this.query = query;
              this.filteredVars = items;
              this.suggestionRange = range;
              this.selectedVarIndex = 0;
              this.renderPopup(virtualNode);
            },
            // is called when a suggestion is cancelled
            onExit: () => {
              // reset all saved values
              this.query = null;
              this.filteredVars = [];
              this.suggestionRange = null;
              this.selectedVarIndex = 0;
              if (this.popup) {
                this.popup.destroy();
                this.popup = null;
              }
              if (this.observer) {
                this.observer.disconnect();
              }
            },
            // is called on every keyDown event while a suggestion is active
            onKeyDown: ({ event }) => {
              let result = false;
              if (event.keyCode === 38) {
                this.selectedVarIndex =
                  ((this.selectedVarIndex + this.filteredVars.length) - 1) %
                  this.filteredVars.length;
                result = true;
              } else if (event.keyCode === 40) {
                this.selectedVarIndex =
                  (this.selectedVarIndex + 1) % this.filteredVars.length;
                result = true;
              } else if (event.keyCode === 13) {
                const item = this.filteredVars[this.selectedVarIndex];
                if (item) {
                  this.selectVar(item);
                }
                result = true;
              }
              return result;
            },
            onFilter: (items, query) => {
              if (!query) {
                return items;
              }
              return items.filter(item => item.startsWith(`@${query}`));
            },
          }),
          new Extensions.History(),
          new Extensions.HorizontalRule(),
          new Extensions.Image(),
          new Extensions.Italic(),
          new Extensions.Link(),
          new Extensions.ListItem(),
          new Extensions.OrderedList(),
          new Extensions.Placeholder(),
          new Extensions.Strike(),
          new Extensions.Underline(),
        ],
      }),
      selectedEmail: {},
      form: {
        text: '',
        email_name: '',
        colly_template_id: null,
        colly_sender_id: null,
      },
      linkUrl: '',
      linkMenuIsActive: false,
      query: null,
      suggestionRange: null,
      filteredVars: [],
      selectedVarIndex: 0,
      editingHtml: false,
      textError: false,
      charLength: 160,
      countCaracteres: 0,
      varsList,
      htmlCode: '',
      insertMention: () => {},
      menuBar: [
        {
          name: 'undo',
          icon: 'fas fa-undo',
        },
        {
          name: 'redo',
          icon: 'fas fa-redo',
        },
        {
          name: 'bold',
          icon: 'fas fa-bold',
          checkActive: true,
        },
        {
          name: 'italic',
          icon: 'fas fa-italic',
          checkActive: true,
        },
        {
          name: 'strike',
          icon: 'fas fa-strikethrough',
          checkActive: true,
        },
        {
          name: 'underline',
          icon: 'fas fa-underline',
          checkActive: true,
        },
        {
          name: 'heading',
          icon: 'fas fa-heading',
          checkActive: true,
          props: {
            level: 1,
          },
        },
        {
          name: 'heading',
          icon: 'fas fa-heading',
          checkActive: true,
          props: {
            level: 2,
          },
        },
        {
          name: 'heading',
          icon: 'fas fa-heading',
          checkActive: true,
          props: {
            level: 3,
          },
        },
        {
          name: 'bullet_list',
          icon: 'fas fa-list',
          checkActive: true,
        },
        {
          name: 'ordered_list',
          icon: 'fas fa-list-ol',
          checkActive: true,
        },
        /*
        {
          name: 'blockquote',
          icon: 'fas fa-quote-right',
        },
        */
        {
          name: 'link',
          icon: 'fas fa-link',
          callback: () => {
            this.linkMenuIsActive = true;
          },
        },
        {
          name: 'code',
          icon: 'fas fa-code',
          checkActive: true,
          active: false,
          callback: () => {
            if (this.editingHtml) {
              this.editor.setContent(this.contentForEditor(this.htmlCode));
            }
            this.editingHtml = !this.editingHtml;
            const index = this.menuBar.length - 1;
            const code = this.menuBar[index];
            code.active = this.editingHtml;
            this.$set(this.menuBar, index, code);
          },
        },
      ],
      originalDaysOff: '',
      csJourneys: [
        {
          id: 1,
          name: 'Gestionando',
        },
        {
          id: 2,
          name: 'Barrido general',
        },
        {
          id: 3,
          name: 'Barrido exitoso',
        },
        {
          id: 4,
          name: 'Conexión',
        },
        {
          id: 5,
          name: 'Contacto',
        },
        {
          id: 6,
          name: 'Contacto directo',
        },
        {
          id: 7,
          name: 'Compromiso',
        },
      ],
      phoneOwners: [
        {
          id: 1,
          name: 'Titular',
        },
        {
          id: 2,
          name: 'Tercero',
        },
        {
          id: null,
          name: 'Todos los teléfonos',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      chatConfig: 'chat_center_config',
    }),
    shortlinkCharacterCount() {
      return Number(process.env.SHORTLINK_CHARACTER_COUNT || 0);
    },
    disabledBtnSave() {
      if (this.usesCollyTemplates) {
        return this.collySendersLoading
          || this.collyTemplatesLoading
          || !!this.collyRequestError
          || !!this.senderLookupError
          || !this.form.colly_template_id
          || this.disabledBtn;
      }
      return this.hasSpecialChar || this.totalCharacter > this.maxChars || this.disabledBtn;
    },
    usesCollyTemplates() {
      // Sin `filter` (flujos viejos) no hay dónde guardar los ids colly: legacy.
      const hasFilter = Object.keys(this.filter).length > 0;
      return this.collyRelease[this.channel] && hasFilter && (this.channel === 'email' || this.channel === 'sms');
    },
    isPaymentType(){
      return 'broken_promises' in this.filterClone;
    },
    maxChars() {
      const { config } = (this.chatConfig || {});
      if (Object.keys(config || {}).length) {
        return config.max_sms_char || 160;
      }
      return 160;
    },
    getStagingEmail() {
      return this.stagingEmail || {};
    },
    getText() {
      let text = 'Hay cambios programados para la próxima carga';
      if (this.stagingMode) {
        text = 'Editando los cambios para la próxima carga';
      }
      return text
    },
    templateStagingForCurrentChannel() {
      const raw = this.templateStaging;
      if (!raw || typeof raw !== 'object') {
        return {};
      }
      if (!Object.keys(raw).length) {
        return {};
      }
      const expected = WORKFLOW_TEMPLATE_STAGING_CHANNEL_IDS[this.channel];
      if (expected === undefined) {
        return raw;
      }
      if (raw.channel_id === undefined || raw.channel_id === null) {
        return raw;
      }
      return Number(raw.channel_id) === expected ? raw : {};
    },
    hasStaging() {
      return Object.keys(this.templateStagingForCurrentChannel).length > 0;
    },
    maxWidth() {
      if (this.isNewWorkflow) {
        return '685px';
      }
      return '600px';
    },
    emptyForm() {
      return {
        ...(this.channel === 'email' && {
          subject: '',
          company_email_id: null,
          ...(this.isNewWorkflow && { email_name: '' }),
        }),
        text: '',
        colly_template_id: null,
        colly_sender_id: null,
        ...(this.channel === 'sms' && {
          sms_enable_short_url: true,
        }),
      };
    },
    hasResults() {
      return this.filteredVars.length;
    },
    showSuggestions() {
      return this.query || this.hasResults;
    },
    hasSpecialChar() {
      let result = false;
      if (this.channel === 'sms' && this.form.text && this.$auth.user().company_id !== 26521363) {
        // form.text SMS es texto plano; permitimos LF/CR (Enter)
        const text = this.form.text;
        result = !(/^[a-zA-ZñÑ0-9+~¡!@#$%^&*\-_()\[\]{};":,./¿?\\|= \n\r]*$/.test(text.replace(new RegExp(`(${this.varsList.join('|')})`, 'g'), ''))); // eslint-disable-line
      }
      return result;
    },
    totalCharacter() {
      if (this.channel !== 'sms') {
        return 0;
      }

      // SMS ya es texto plano (incluye saltos como 1 caracter c/u)
      const text = this.form.text || '';
      const textLength = text.length || 0;

      if (!textLength) {
        return textLength;
      }

      if (!this.form.sms_enable_short_url) {
        return textLength;
      }

      // Si hay un link, se resta a la cantidad de caracteres el largo del link
      const urlRegex = /(?:(?:https?:)?\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?/g;
      const matches = text.match(urlRegex) || [];
      const urlLength = matches.reduce((acc, curr) => acc + curr.length, 0);

      return textLength - urlLength + (this.shortlinkCharacterCount * matches.length);
    },
    changeDaysOff() {
      return this.filterClone[`days_off_${this.daysOffG[this.channel]}`] != this.originalDaysOff;
    },
  },
  methods: {
    mapCollyTemplates(items) {
      return items.map((template) => ({
        ...template,
        display_name: template.name,
      }));
    },
    mapCollySenders(raw) {
      const list = Array.isArray(raw) ? raw : (raw && (raw.items || raw.data)) || [];
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item) => ({
        ...item,
        id: item.senderId || item.sid,
        display_name: item.address || item.name || item.senderId || item.sid,
      }));
    },
    collyRequestErrorMessage(error) {
      const response = error && error.response;
      const data = response && response.data;
      const status = response && response.status;
      let detail = '';
      if (data && typeof data === 'object') {
        try {
          detail = JSON.stringify(data);
        } catch (err) {
          detail = '';
        }
      } else if (typeof data === 'string') {
        const trimmed = data.replace(/\s+/g, ' ').trim();
        if (trimmed && trimmed.charAt(0) !== '<') {
          detail = trimmed.slice(0, 500);
        }
      }
      const statusText = status ? ` (${status})` : '';
      return detail
        ? `La petición a Colly falló${statusText}. ${detail}`
        : `La petición a Colly falló${statusText}.`;
    },
    async loadCollySenders() {
      this.collySendersLoading = true;
      this.senderLookupError = '';
      try {
        const { data } = await this.axios.get('colly/senders', { params: { channel: this.channel } });
        this.collySenders = this.mapCollySenders(data);
      } catch (e) {
        this.collySenders = [];
        this.senderLookupError = this.collyRequestErrorMessage(e);
      } finally {
        this.collySendersLoading = false;
      }
      const exists = this.collySenders.some(item => item.id === this.form.colly_sender_id);
      if (!this.form.colly_sender_id || exists) {
        return;
      }
      // El remitente guardado ya no está: queda "Por defecto" con las plantillas de todo el canal.
      this.form.colly_sender_id = null;
      this.loadCollyTemplates();
    },
    async loadCollyTemplates() {
      const senderId = this.form.colly_sender_id;
      this.collyTemplatesLoading = true;
      this.collyRequestError = '';
      // Sin remitente ("Por defecto") axios omite compatibleWith: todas las plantillas del canal.
      const response = await this.axios.get('colly/templates', {
        params: { channel: this.channel, compatibleWith: senderId },
      }).catch(error => ({ error }));
      // El remitente cambió mientras cargaba: vale la respuesta del último.
      if (senderId !== this.form.colly_sender_id) {
        return;
      }
      this.collyTemplatesLoading = false;
      if (response.error) {
        this.collyTemplates = [];
        this.form.colly_template_id = null;
        this.collyRequestError = this.collyRequestErrorMessage(response.error);
        return;
      }
      this.collyTemplates = this.mapCollyTemplates((response.data && response.data.items) || []);
      if (!this.collyTemplates.some(template => template.id === this.form.colly_template_id)) {
        this.form.colly_template_id = null;
      }
    },
    checkTemplate() {
      if (this.hasStaging || !this.activateCheck) {
        this.save();
      } else {
        this.showChecker = true;
      }
    },
    doubleCheckPassed(e) {
      this.showChecker = false;
      this.stagingMoment = e.value;
      this.save();
    },
    changeTemplate() {
      // this.editingHtml = false;
      if (this.stagingMode) {
        this.stagingMode = false;
        this.form = {
          ...this.emptyForm,
          ...this.template,
        };
      } else {
        this.stagingMode = true;
        this.form = {
          ...this.emptyForm,
          ...this.templateStagingForCurrentChannel,
        };
      }
      const text = this.replaceVars(this.form.text);
      this.editor.setContent(this.contentForEditor(text));
      this.htmlCode = this.channel === 'sms' ? this.smsTextToEditorHtml(text) : text;
    },
    clearErrors() {
      this.textError = false;
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, this.validationScope);
      });
    },
    removeHtmlTags(text) {
      return text.replace(/(<([^>]+)>)/gi, '').trim();
    },
    removeHtmlTagsHard(text) {
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      return tmp.textContent || tmp.innerText || '';
    },
    smsHtmlToPlainText(html) {
      const withBreaks = String(html || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<\/div>/gi, '\n');
      const tmp = document.createElement('div');
      tmp.innerHTML = withBreaks;
      return (tmp.textContent || tmp.innerText || '').replace(/\n+$/g, '');
    },
    smsTextToEditorHtml(text) {
      return String(text || '').replace(/\n/g, '<br>');
    },
    contentForEditor(textWithMentions) {
      if (this.channel !== 'sms') {
        return textWithMentions;
      }
      return this.smsTextToEditorHtml(textWithMentions);
    },
    replaceVars(text) {
      let modifiedText = text;
      this.varsList.forEach((item) => {
        let regExpr;
        if (item === '@nombre') {
          regExpr = new RegExp('@nombre(?!_)', 'g');
        } else {
          regExpr = new RegExp(`\\b${item}\\b`, 'g');
        }
        const name = item.replace(/@/, '');
        modifiedText = modifiedText.replace(
          regExpr,
          `<span class="mention" data-mention-id="${name}">${item}</span>`,
        );
      });

      return modifiedText;
    },
    editEmail() {
      const index = this.emailList.findIndex(item => item.id === this.form.company_email_id);
      this.selectedEmail = this.emailList[index];
      this.emailDialog = true;
    },
    updateEmail(email) {
      const index = this.emailList.findIndex(item => item.id === email.id);
      this.$set(this.emailList, index, email);
    },
    hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl(command, url) {
      command({ href: url });
      this.hideLinkMenu();
      this.editor.focus();
    },
    selectVar(variable) {
      const text = variable.replace(/@/, '');
      this.insertMention({
        range: this.suggestionRange,
        attrs: {
          id: text,
          label: text,
        },
      });
      this.editor.focus();
    },
    renderPopup(node) {
      if (this.popup) {
        return;
      }
      this.popup = tippy(node, {
        content: this.$refs.suggestions,
        trigger: 'mouseenter',
        interactive: true,
        theme: 'light',
        placement: 'top-start',
        inertia: true,
        duration: [400, 200],
        showOnInit: true,
        arrow: true,
        arrowType: 'round',
      });
    },
    destroyPopup() {
      if (this.popup) {
        this.popup.destroy();
        this.popup = null;
      }
    },
    save() {
      if (this.usesCollyTemplates) {
        this.textError = false;
        const formToSend = {
          ...this.form,
          channel: this.channel,
          actionType: 'save',
          momentToApply: 'now',
          [`colly_${this.channel}_template_id`]: this.form.colly_template_id,
          [`colly_${this.channel}_sender_id`]: this.form.colly_sender_id,
        };
        formToSend[`days_off_${this.daysOffG[this.channel]}`] = this.filterClone[`days_off_${this.daysOffG[this.channel]}`];
        formToSend[`days_off_attemps_${this.daysOffG[this.channel]}`] = this.filterClone[`days_off_attemps_${this.daysOffG[this.channel]}`];
        formToSend[`attemps_${this.daysOffG[this.channel]}`] = this.filterClone[`attemps_${this.daysOffG[this.channel]}`];
        formToSend[`${this.channel}_owner_id`] = this.filterClone[`${this.channel}_owner_id`];
        formToSend.sms_cs_journey = this.filterClone.sms_cs_journey;
        formToSend.sms_check_days = this.filterClone.sms_check_days;
        formToSend.only_contacted_sms = this.filterClone.only_contacted_sms;
        this.$emit('save', formToSend);
        this.$emit('close');
        return;
      }
      if (this.channel === 'email' && this.editingHtml) {
        this.form.text = this.htmlCode;
      } else if (this.channel === 'sms') {
        this.form.text = this.smsHtmlToPlainText(this.htmlCode);
      } else if (this.channel !== 'email') {
        this.form.text = this.removeHtmlTagsHard(this.htmlCode);
      }
      if (this.totalCharacter > this.maxChars && this.channel === 'sms') {
        return;
      } else if (this.channel === 'sms' && this.hasSpecialChar) {
        return;
      }
      if (
        !this.form.text.trim().length ||
        (
          this.channel === 'email'
          && !this.removeHtmlTags(this.form.text).length
        )
      ) {
        this.textError = true;
      }
      if (this.channel === 'human') {
        this.textError = false;
      }
      this.$validator.validateAll(this.validationScope).then((validation) => {
        if (validation && !this.textError) {
          const formToSend = {
            ...this.form,
            channel: this.channel,
            actionType: 'save',
            momentToApply: this.stagingMoment.length ? this.stagingMoment : 'now',
          }

          if (this.stagingMoment === 'after load') {
            formToSend.actionType = 'create';
          }

          if (this.stagingMode && this.hasStaging) {
            formToSend.momentToApply = 'after load';
            formToSend.actionType = 'update';
          }

          formToSend[`days_off_${this.daysOffG[this.channel]}`] = this.filterClone[`days_off_${this.daysOffG[this.channel]}`];
          formToSend[`days_off_attemps_${this.daysOffG[this.channel]}`] = this.filterClone[`days_off_attemps_${this.daysOffG[this.channel]}`];
          formToSend[`attemps_${this.daysOffG[this.channel]}`] = this.filterClone[`attemps_${this.daysOffG[this.channel]}`];
          formToSend[`${this.channel}_owner_id`] = this.filterClone[`${this.channel}_owner_id`];
          formToSend.sms_cs_journey = this.filterClone.sms_cs_journey;
          formToSend.sms_check_days = this.filterClone.sms_check_days;
          formToSend.only_contacted_sms = this.filterClone.only_contacted_sms;
          formToSend.sms_enable_short_url = this.form.sms_enable_short_url;
          console.log("form to send", formToSend)
          this.$emit('save', formToSend);
          this.$emit('close');
          this.form = {};
          this.stagingMoment = '';
        }
      })
      .finally(() => {
        this.showChecker = false;
      });
    },
    setPhoneOrEmailVars() {
      if (this.channel === 'email') {
        const index = this.varsList.indexOf('@telefono');
        if (index >= 0) {
          this.varsList.splice(index, 1, '@email');
        } else if (!this.varsList.includes('@email')) {
          this.varsList.unshift('@email');
        }
      } else {
        const index = this.varsList.indexOf('@email');
        if (index >= 0) {
          this.varsList.splice(index, 1, '@telefono');
        } else if (!this.varsList.includes('@telefono')) {
          this.varsList.unshift('@telefono');
        }
      }
    },
    greaterThanZeroInputRule() {
      if (this.filterClone.sms_check_days !== 0) {
        return true;
      }
      return 'La cantidad de días en consideración debe ser mayor a cero';
    },
  },
  watch: {
    show() {
      this.stagingMode = false;
      if (this.show) {
        this.filterClone = _.clone(this.filter);
        this.editingHtml = false;
        this.form = {
          ...this.emptyForm,
          ...this.template,
        };
        const text = this.replaceVars(this.form.text);
        this.editor.setContent(this.contentForEditor(text));
        this.htmlCode = this.channel === 'sms' ? this.smsTextToEditorHtml(text) : text;
        this.originalDaysOff = this.filterClone[`days_off_${this.daysOffG[this.channel]}`];
        this.collyTemplates = [];
        this.collySenders = [];
        this.collyRequestError = '';
        this.senderLookupError = '';
        if (this.usesCollyTemplates) {
          this.form.colly_template_id = this.filter[`colly_${this.channel}_template_id`] || null;
          this.form.colly_sender_id = this.filter[`colly_${this.channel}_sender_id`] || null;
          this.loadCollySenders();
          this.loadCollyTemplates();
        }
        if (!this.emailList.length && this.channel === 'email') {
          this.axios
            .get('v2/company_emails')
            .then((response) => {
              this.emailList = response.data;
              this.dialog = true;
            })
            .catch(() => {});
        } else {
          this.dialog = true;
        }
      } else {
        this.dialog = false;
        this.collyRequestError = '';
        setTimeout(this.clearErrors, 200);
      }
      if (this.show) {
        this.setPhoneOrEmailVars();
      }
    },
    emailDialog() {
      if (!this.emailDialog) {
        this.selectedEmail = {};
      }
    },
    htmlCode: {
      immediate: true,
      handler(value) {
        if (this.channel === 'sms') {
          const plain = this.smsHtmlToPlainText(value);
          if (plain !== this.form.text) {
            this.form.text = plain;
          }
          return;
        }
        if (value !== this.form.text) {
          this.form.text = value;
        }
      },
    },
  },
};
</script>

<style scoped>
textarea {
  position: relative !important;
}
#html-text {
  height: 180px !important;
}
.template-editor >>> .ProseMirror {
  display: block !important;
  width: 100% !important;
  border: 0 !important;
  padding: 10px 5px !important;
  background: #fff no-repeat !important;
  background-image: linear-gradient(to bottom, #000, #000),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.42), rgba(0, 0, 0, 0.42)) !important;
  background-size: 0 2px, 100% 1px !important;
  background-position: 50% 100%, 50% 100% !important;
  transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1) !important;
}
.template-editor >>> .ProseMirror:focus {
  background-size: 100% 2px, 100% 1px !important;
  outline: none;
}
.template-editor >>> .ProseMirror {
  height: 180px !important;
  overflow: auto !important;
}
.template-editor >>> p.is-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
.template-editor >>> .mention,
.template-editor >>> .mention-suggestion {
  color: rgba(0, 0, 0, 0.6);
}
.template-editor >>> .mention {
  background: rgba(0, 0, 0, 0.1);
  font-weight: 700;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
}
.suggestion-list {
  padding: 0.2rem;
  font-weight: 700;
  font-family: Roboto, sans-serif;
}
.suggestion-list__item.is-selected,
.suggestion-list__item:hover {
  background-color: #1976d2;
  color: #fff;
}
.suggestion-list__item {
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  margin-bottom: 0.2rem;
  cursor: pointer;
}
.suggestion-list__item.is-empty {
  opacity: 0.5;
}
.suggestion-list__item:last-child {
  margin-bottom: 0;
}
.menububble {
  position: absolute;
  left: 190px !important;
  bottom: 15px !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  z-index: 20;
  background: #000;
  border-radius: 5px;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  -webkit-transition: opacity 0.2s, visibility 0.2s;
  transition: opacity 0.2s, visibility 0.2s;
}
.menububble.is-active {
  opacity: 1;
  visibility: visible;
}
.menububble__form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.menububble__input {
  font: inherit;
  border: none;
  background: rgba(0, 0, 0, 0);
  color: #fff;
}
.menububble__button:last-child {
  margin-right: 0;
}
.menububble__button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  background: rgba(0, 0, 0, 0);
  border: 0;
  color: #fff;
  padding: 0.2rem 0.5rem;
  margin-right: 0.2rem;
  border-radius: 3px;
  cursor: pointer;
}
.activeClass {
  color: red;
}
.template-editor >>> ul {
  list-style: disc !important;
  padding-left: 15px;
}
.template-editor >>> ol {
  list-style: decimal !important;
  padding-left: 15px;
}
.template-staging-div {
  color: #1976d2;
}
.template-staging-div:hover {
  cursor: pointer;
}
.sms-config-checkbox >>> label {
  max-width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/Index.vue